__turbopack_context__.v({
  "back": "flipperCard-module-scss-module__7ouoJa__back",
  "clockwise": "flipperCard-module-scss-module__7ouoJa__clockwise",
  "counterclockwise": "flipperCard-module-scss-module__7ouoJa__counterclockwise",
  "flip": "flipperCard-module-scss-module__7ouoJa__flip",
  "flipContainer": "flipperCard-module-scss-module__7ouoJa__flipContainer",
  "flipped": "flipperCard-module-scss-module__7ouoJa__flipped",
  "flipper": "flipperCard-module-scss-module__7ouoJa__flipper",
  "front": "flipperCard-module-scss-module__7ouoJa__front",
});
